/**
 * @generated SignedSource<<2f332029bf7e81f360e479392197e1fc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerApplicationWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationBenefits_viewer" | "SellerApplicationForm_viewer">;
  readonly " $fragmentType": "SellerApplicationWrapper_viewer";
};
export type SellerApplicationWrapper_viewer$key = {
  readonly " $data"?: SellerApplicationWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerApplicationWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "leadId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerApplicationWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SellerApplicationBenefits_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "leadId",
          "variableName": "leadId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "SellerApplicationForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7619659bd0392b6d92a8f3414d631ef4";

export default node;
